import { Fragment } from 'react';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { Typography } from '@/components/Typography';
import type { SectionsOpts } from '@/integrations/contentful';
import {
  type ContentfulData,
  filterContentfulCollection,
  generateSectionKey,
} from '@/integrations/contentful';
import { useRecentlyViewedProducts } from '@/views/WatchView/helper';

import { renderContentfulSearchNoResultsSection } from './cms';

import * as M from './messages';

type SearchNoResultsProps = {
  draftMode: boolean;
  noResultContentData?: ContentfulData[];
};

export const SearchNoResults = ({
  draftMode,
  noResultContentData,
}: SearchNoResultsProps) => {
  const data = filterContentfulCollection(noResultContentData);

  const recentlyViewedProductReference = useRecentlyViewedProducts(null);
  const cmsSectionOpts: SectionsOpts = [
    {
      opts: {
        type: 'recently viewed',
        filter: { slugs: recentlyViewedProductReference },
        excludeSlug: undefined,
      },
      type: 'SliderProductsAutomatic',
    },
  ];

  return data.length > 0 ? (
    <>
      {data.map((data, i) => (
        <Fragment key={generateSectionKey(data, i)}>
          {renderContentfulSearchNoResultsSection(
            data,
            cmsSectionOpts,
            draftMode,
          )}
        </Fragment>
      ))}
    </>
  ) : (
    <Flex
      data-test-id='SearchNoResultsContainer'
      flexDirection='column'
      gridGap={5}
    >
      <Box mb={2} mt={2}>
        <Flex flexDirection='column' gridGap={2}>
          <Typography
            data-test-id='SearchNoResultsHeading'
            fontWeight='regular'
            scale='h3'
            textAlign='center'
            textTransform='uppercase'
          >
            {M.NoResults}
          </Typography>

          <Typography
            data-test-id='SearchNoResultsMessage'
            scale='p1'
            textAlign='center'
          >
            {M.TryDifferentSearch}
          </Typography>
        </Flex>
      </Box>
    </Flex>
  );
};

SearchNoResults.displayName = 'SearchNoResults';
